import { Stack, Typography } from '@mui/material';
import { Fragment } from 'react';

export type ItemSeparatorItem = string | React.ReactNode;

type Props = {
  items: ItemSeparatorItem[];
};

export const ItemSeparator: React.FC<Props> = ({ items }) => {
  return (
    <Stack direction="row" gap="8px" alignItems="center">
      {items.map((item, index) => (
        <Fragment key={index}>
          <Typography variant="body1" color="customGrey.dark">
            {item}
          </Typography>
          {index < items.length - 1 && (
            <Typography color="customGrey.dark">|</Typography>
          )}
        </Fragment>
      ))}
    </Stack>
  );
};
